module.exports = __webpack_public_path__ + "static/add-meiyu-qrcode.th-6074775cfdedaaa729406483b9dda7a7.svg";